import 'slick-carousel/slick/slick.min';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import Modernizr from 'modernizr';
import LazyLoad from "vanilla-lazyload";
import Paroller from 'paroller.js';
import Isotope from 'isotope-layout/dist/isotope.pkgd.min';

export default class Ux {
    constructor()
    {
        Ux.initializeJsClick();
        Ux.initializeBootstrapTooltip();
        Ux.initializeFancybox();
        Ux.initializeSearchBox();
        Ux.initializeBackToTop();
        Ux.initializeSmoothScroll();
        Ux.initializeLazy();
        Ux.initializeOnScroll();
        Ux.initializeVideoGutenberg();
        Ux.initializeParallax();
        Ux.initializeIsotope();
        Ux.initializeInstagram();
        Ux.initializeBlogScroll();
        Ux.initializePopup();
        Ux.initializeAlert();
        Ux.initializeMenu();
    }
    
    static initializeJsClick()
    {
        if ( !Modernizr.touchevents ) {
            let ctrl = 0;
            $( window ).on( 'keydown', function ( e ) {
                if ( e.which == 17 || e.which == 91 ) {
                    
                    ctrl = true;
                }
            } );
            
            $( window ).on( 'keyup', function () {
                ctrl = false;
            } );
            
            $( document ).on( 'mouseup', '.js-click', function ( e ) {
                if ( e.which == 1 || e.which == 2 ) {
                    let blank = false;
                    let url   = $( this ).find( "a" ).attr( "href" );
                    if ( e.which == 2 ) {
                        blank = true;
                    } // Clic molette
                    if ( $( this ).find( "a" ).attr( "target" ) == "_blank" ) {
                        blank = true;
                    }
                    if ( blank || ctrl ) {
                        window.open( url, '_blank' );
                    } else {
                        window.location = url;
                    }
                    return false;
                }
                return false;
                
            } );
        } else {
            $( document ).on( 'click', '.js-click', function ( e ) {
                
                let blank = false;
                let url   = $( this ).find( "a" ).attr( "href" );
                if ( $( this ).find( "a" ).attr( "target" ) == "_blank" ) {
                    blank = true;
                }
                if ( blank ) {
                    window.open( url, '_blank' );
                } else {
                    window.location = url;
                }
                return false;
                
            } );
        }
    }
    
    static initializeBootstrapTooltip()
    {
        if ( !Modernizr.touchevents ) {
            $( '[data-toggle="tooltip"], [rel="tooltip"]' ).tooltip( { trigger: "hover" } );
        }
    }
    
    static initializeFancybox()
    {
        
        $( '.article a:has(>img):not([target="_blank"]):not(".no-fancybox")' ).attr( 'data-fancybox', 'fancybox' );
        
        $( "[data-fancybox='fancybox']" ).fancybox( {
                                                        buttons: [
                                                            "zoom",
                                                            //"share",
                                                            "slideShow",
                                                            //"fullScreen",
                                                            //"download",
                                                            //"thumbs",
                                                            "close"
                                                        ],
                                                        lang: "fr",
                                                        i18n: {
                                                            fr: {
                                                                CLOSE: Theme.translate.fancyboxClose,
                                                                NEXT: Theme.translate.fancyboxNext,
                                                                PREV: Theme.translate.fancyboxPrev,
                                                                ERROR: Theme.translate.fancyboxError,
                                                                PLAY_START: Theme.translate.fancyboxStart,
                                                                PLAY_STOP: Theme.translate.fancyboxStop,
                                                                FULL_SCREEN: Theme.translate.fancyboxFullScreen,
                                                                THUMBS: Theme.translate.fancyboxThumbs,
                                                                DOWNLOAD: Theme.translate.fancyboxDownload,
                                                                SHARE: Theme.translate.fancyboxShare,
                                                                ZOOM: Theme.translate.fancyboxZoom
                                                            },
                                                        },
                                                        caption: function ( instance, item ) {
                                                            let caption = $( this ).closest( 'figure' ).find( 'figcaption' ).html();
                
                                                            if ( !caption ) {
                                                                caption = $( this ).find( 'img' ).attr( 'title' );
                                                            }
                                                            
                                                            return caption;
                                                        }
                                                    } );
    }
    
    static initializeSearchBox()
    {
        $( '.js-wpSearchLayoutOpen' ).on( 'click', function ( e ) {
            e.preventDefault();
            $( '.wpSearchLayout' ).addClass('is-active');
            $( 'body' ).toggleClass( 'modalOpen' );
            setTimeout( function () {
                $( '.wpSearchFormItem--input' ).focus();
            }, 100 );
        } );
        
        $( '.js-wpSearchLayoutClose' ).on( 'click', function ( e ) {
            e.preventDefault();
            $( 'body' ).toggleClass( 'modalOpen' );
            $( '.wpSearchLayout' ).removeClass('is-active');
        } );
    }
    
    static initializeBackToTop()
    {
        $( '.js-backToTop' ).on( 'click', function ( e ) {
            e.preventDefault();
            
            if ( $( window ).scrollTop() != 0 ) {
                $( 'html, body' ).animate( { scrollTop: 0 }, 300 );
            }
        } );
        
        $( window ).on( 'scroll', function ( e ) {
            
            if ( $( this ).scrollTop() > 250 ) {
                $( '.js-backToTop' ).addClass( 'backToTop--show' );
            } else {
                $( '.js-backToTop' ).removeClass( 'backToTop--show' );
            }
        } );
    }
    
    static initializeSmoothScroll()
    {
        $( '.js-scroll' ).click( function ( e ) {
            e.preventDefault();
            
            let target   = $( this ).find( 'a' ).attr( 'href' );
            let duration = 1000;
            
            $( 'html, body' ).animate( {
                                           scrollTop: $( target ).offset().top
                                       }, duration );
            
        } );
    }
    
    static initializeLazy()
    {
        let lazyLoadInstance = new LazyLoad( {
                                                 elements_selector: "[data-src], [data-bg]"
                                             } );
    }
    
    static initializeOnScroll()
    {
        let last_scroll_top = 0;
        $( window ).on( 'load scroll', function () {
            
            let scroll_top = $( this ).scrollTop();
            let $header    = $( '.navbar' );
            
            if ( scroll_top >= last_scroll_top && scroll_top > $header.outerHeight() ) {
                // Down
                $( 'body' ).addClass( 'header-is-hidden' );
            } else {
                // Up
                $( 'body' ).removeClass( 'header-is-hidden' );
            }
            
            last_scroll_top = scroll_top;
            
            // Site header color
            if ( $( '.header-is-transparent' ).length ) {
                
                if ( scroll_top > 100 ) {
                    $header.removeClass( 'navbar--transparent' );
                } else {
                    $header.addClass( 'navbar--transparent' );
                }
            }
        } );
    }
    
    static initializeVideoGutenberg()
    {
        var block  = '.wp-block-video',
            $video = $( '.wp-block-video video' );
        
        if ( $video.length > 0 ) {
            $video.on( 'click', function ( e ) {
                e.preventDefault();
                
                var video = this;
                
                if ( video.paused ) {
                    video.play();
                } else {
                    video.pause();
                }
            } );
            $video.each( function () {
                
                var video = this;
                
                $( video ).on( 'ended', function () {
                    // video.controls = false;
                    // video.currentTime = 0;
                    $( video ).parent().removeClass( 'is-playing' );
                } );
                
                $( video ).on( 'playing', function () {
                    // video.controls = true;
                    $( video ).parent().addClass( 'is-playing' );
                } );
                
                $( video ).on( 'pause', function () {
                    $( video ).parent().removeClass( 'is-playing' );
                    // video.controls = false;
                } );
            } );
        }
    }
    
    static initializeParallax()
    {
        if ( window.matchMedia( "(min-width: 1000px)" ).matches ) {
            $( '[data-paroller]' ).paroller();
        }
    }
    
    static initializeIsotope()
    {
        
        let grid             = document.querySelector( '[data-isotope-grid]' ),
            item             = '[data-isotope-item]',
            gutterSize       = 40,
            gutterSizeTablet = 30,
            gutterSizeMobile = 20,
            stamp            = '[data-isotope-stamp]';
        
        if ( window.matchMedia( "(max-width: 1000px) AND (min-width: 659px)" ).matches ) {
            gutterSize = gutterSizeTablet;
        }
        
        if ( window.matchMedia( "(max-width: 650px)" ).matches ) {
            gutterSize = gutterSizeMobile;
        }
        
        if ( document.body.contains( grid ) && (window.matchMedia( "(min-width: 370px)" ).matches) ) {
            
            $( window ).load( function () {
                setTimeout( function () {
                    let iso = new Isotope( grid, {
                        stamp: stamp,
                        masonry: {
                            itemSelector: item,
                            gutter: gutterSize,
                        }
                    } );
                }, 200 );
            } );
        }
    }
    
    static initializeInstagram()
    {
        
        let $wrapper = $( '[data-instagram-wall]' );
        
        if ( $wrapper.length > 0 ) {
            self = this;
            $.ajax( {
                        url: Theme.ajaxURL,
                        data: {
                            'action': 'social_wall',
                        },
                        type: 'POST',
                        success: function ( socialData ) {
                            $wrapper.append( socialData );
                            self.initializeLazy();
                        }
                    } );
        }
    }
    
    static initializeBlogScroll()
    {
        let url = window.location.href;
        if ( (url.indexOf( "/categorie/" ) >= 1) && ($( '.banner--big' ).length > 0) ) {
            $( 'html, body' ).animate( {
                                           scrollTop: $( window ).height()
                                       }, 1000 );
        }
    }
    
    static initializePopup()
    {
        const close    = '[data-trigger="wpiris-popup-close"]',
              $element = $( '[data-id="wpiris-popup"]' );
        
        $( document ).on( 'click', close, function ( e ) {
            e.preventDefault();
            $element.css( 'margin-left', '-100%' );
        } );
    }
    
    static initializeAlert()
    {
        const close    = '[data-trigger="wpiris-alert-close"]',
              $element = $( '[data-id="wpiris-alert"]' ),
              position = $element.attr( 'data-position' );
        
        if ( $element.length > 0 ) {
            if ( position ) {
                let positions = position.split( ' ' );
                $element.css( {
                                  "position": 'fixed',
                                  "top": positions[ 0 ],
                                  "right": positions[ 1 ],
                                  "bottom": positions[ 2 ],
                                  "left": positions[ 3 ],
                              } );
            }
        }
        
        $( document ).on( 'click', close, function ( e ) {
            e.preventDefault();
            $element.toggleClass( 'close' );
        } );
    }
    
    static initializeMenu()
    {
        const trigger     = '[data-trigger="wpiris-menu-toggle"]',
              $element    = $( '[data-id="wpiris-menu"]' ),
              elementItem = '[data-id="wpiris-menu-item"]',
              triggerMore = '[data-trigger="wpiris-menu-more"]',
              triggerBack = '[data-trigger="wpiris-menu-back"]';
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            $element.toggleClass( 'open' );
            $( trigger ).toggleClass( 'open' );
            $( 'body' ).toggleClass( 'menuOpen' );
            $( elementItem ).removeClass( 'submenuActive' );
        } );
        
        $( document ).on( 'click', triggerMore, function ( e ) {
            $( elementItem ).removeClass( 'submenuActive' );
            $( this ).parents( elementItem ).addClass( 'submenuActive' );
        } );
        
        $( document ).on( 'click', triggerBack, function ( e ) {
            $( this ).parents( elementItem ).removeClass( 'submenuActive' );
        } );
    }
    
}
